import BackendService from '../../../services/admin/BackendService';
import type { BulkPromoteInvestorItem } from './investorManagementTypes';
import { getNextStage, requiresInvestmentAmount } from './investorPromotionUtils';

export async function submitBulkPromotionRequest(
  bulkPromoteInvestors: BulkPromoteInvestorItem[],
  bulkPromoteStage: BulkPromoteInvestorItem['investor']['status'],
): Promise<void> {
  const service = new BackendService();
  const hasErrors = bulkPromoteInvestors.some(
    (item) =>
      !item.preferredInvestment ||
      (item.preferredInvestment <= 0 && requiresInvestmentAmount(bulkPromoteStage)),
  );

  if (hasErrors) {
    alert('Please enter valid investment amounts for all investors.');
    return;
  }

  const pendingItems = bulkPromoteInvestors.filter((item) => item.preferredInvestment);
  const promises = pendingItems.map((item) => {
    const nextStage = getNextStage(bulkPromoteStage);
    if (item.investor.status === 'LEAD' && nextStage === 'OPPORTUNITY') {
      return service.promoteToOpportunity(item.investor.id, item.preferredInvestment as number);
    }
    if (item.investor.status === 'OPPORTUNITY' && nextStage === 'COMMITTED_INVESTOR') {
      return service.commitInvestment(item.investor.id, item.committedInvestment as number);
    }
    if (item.investor.status === 'CANDIDATE' && nextStage === 'LEAD') {
      return service.promoteToLead(item.investor.id);
    }
    throw new Error(`Unsupported bulk promotion: ${item.investor.status} -> ${nextStage}`);
  });

  await Promise.all(promises);
}
